import { all, call, put, select, take } from 'redux-saga/effects'
import basicSaga from './basic'
import { initUser } from './basic/user'
import { initLayout } from './basic/layout'
import workbenchSaga, { initWorkbench } from './workbench'
import layoutTypes from '@redux/types/basic/layout'

export function* ensureApplicationMenu() {
  const hasUserSession = yield select(state =>
    Boolean(state.user.users && state.user.users.token)
  )

  if (!hasUserSession) return

  // Refresh authorization on boot; cached menus may predate role changes.
  yield put({
    type: layoutTypes.GET_APPLICATIONS
  })
  yield take([
    `${layoutTypes.GET_APPLICATIONS}@DONE`,
    `${layoutTypes.GET_APPLICATIONS}@ERROR`
  ])
}

function* initialSaga() {
  console.log(`

   ______     ______     ______     ______     __   __     ______   __  __     ______     ______
  /\\  __ \\   /\\  ___\\   /\\  ___\\   /\\  ___\\   /\\ "-.\\ \\   /\\__  _\\ /\\ \\/\\ \\   /\\  == \\   /\\  ___\\
  \\ \\  __ \\  \\ \\ \\____  \\ \\ \\____  \\ \\  __\\   \\ \\ \\-.  \\  \\/_/\\ \\/ \\ \\ \\_\\ \\  \\ \\  __<   \\ \\  __\\
   \\ \\_\\ \\_\\  \\ \\_____\\  \\ \\_____\\  \\ \\_____\\  \\ \\_\\\\"\\_\\    \\ \\_\\  \\ \\_____\\  \\ \\_\\ \\_\\  \\ \\_____\\
    \\/_/\\/_/   \\/_____/   \\/_____/   \\/_____/   \\/_/ \\/_/     \\/_/   \\/_____/   \\/_/ /_/   \\/_____/

   ______     ______     ______
  /\\  __ \\   /\\  == \\   /\\  ___\\
  \\ \\  __ \\  \\ \\  __<   \\ \\ \\__ \\
   \\ \\_\\ \\_\\  \\ \\_____\\  \\ \\_____\\
    \\/_/\\/_/   \\/_____/   \\/_____/

   ______     ______     __         __  __     ______   __     ______     __   __
  /\\  ___\\   /\\  __ \\   /\\ \\       /\\ \\/\\ \\   /\\__  _\\ /\\ \\   /\\  __ \\   /\\ "-.\\ \\
  \\ \\___  \\  \\ \\ \\/\\ \\  \\ \\ \\____  \\ \\ \\_\\ \\  \\/_/\\ \\/ \\ \\ \\  \\ \\ \\/\\ \\  \\ \\ \\-.  \\
   \\/\\_____\\  \\ \\_____\\  \\ \\_____\\  \\ \\_____\\    \\ \\_\\  \\ \\_\\  \\ \\_____\\  \\ \\_\\\\"\\_\\
    \\/_____/   \\/_____/   \\/_____/   \\/_____/     \\/_/   \\/_/   \\/_____/   \\/_/ \\/_/


 `)

  yield call(initLayout)
  // NOTE: 准备好所有数据再回复用户数据
  yield call(initUser)
  yield call(ensureApplicationMenu)
  yield call(initWorkbench)
}

export default function* rootSaga() {
  yield all([initialSaga(), basicSaga(), workbenchSaga()])
}
